import { Component, OnInit } from '@angular/core';
import { FuiBaseModal } from 'ngx-fomantic-ui';
import { FormGroup } from '@angular/forms';
import { RxFormBuilder } from '@rxweb/reactive-form-validators';

import { SharedService } from './../../../shared/services/shared.service';
import { NotifyAlertService } from '@monorepo/ui';
import { FavouriteForm } from '../../../screen-listing-item/components/listing-item-model';
import {
  ScreenListing,
  FavouriteScreens,
  FavouriteScreenItem,
} from '../../../shared';

export interface IConfirmModalContext {
  title: string;
  content: ScreenListing;
}

enum FavouriteState {
  FAVOURITE_LIST,
  ADD_FAVOURITE,
  NO_LIST,
}

@Component({
  selector: 'signgaze-favourite-screen-modal',
  templateUrl: './favourite-screen-modal.component.html',
  styleUrls: ['./favourite-screen-modal.component.scss'],
})
export class FavouriteScreenModalComponent implements OnInit {
  isaddedList = true;
  favouriteListForm: FormGroup;
  favouriteList: FavouriteScreens[] = [];
  favouriteState = FavouriteState;
  currentState: FavouriteState = FavouriteState.FAVOURITE_LIST;
  favouriteItem: FavouriteScreenItem = {};
  screen: ScreenListing;

  constructor(
    public modal: FuiBaseModal<IConfirmModalContext, void, void>,
    private sharedService: SharedService,
    private rxFb: RxFormBuilder,
    private notifyAlertService: NotifyAlertService
  ) {}

  ngOnInit(): void {
    this.screen = this.modal.context.content;
    this.createCategoryForm();
    this.getFavList();
  }

  public createList(): void {
    if (this.favouriteListForm.invalid) {
      this.favouriteListForm.markAllAsTouched();
      return;
    }
    this.favouriteItem.screenId = this.screen.id;
    this.saveItem(this.favouriteListForm.value);
  }

  private saveItem(favouriteList): void {
    this.sharedService
      .createFavouriteList(favouriteList, this.favouriteItem)
      .subscribe({
        next: (): void => {
          this.notifyAlertService.success('succesfully added in favourites.');
          this.favouriteItem = null;
          this.modal.approve();
        },
      });
  }

  private updateList(list: FavouriteScreens): void {
    this.favouriteItem.screenId = this.screen.id;
    this.sharedService
      .updateFavouriteList(list.id, this.favouriteItem)
      .subscribe((): void => {
        this.notifyAlertService.success('succesfully added in favourites.');
        this.favouriteItem = null;
        this.modal.approve();
      });
  }

  public addToFavouriteList(list: FavouriteScreens): void {
    this.updateList(list);
  }

  public createCategoryForm(): void {
    this.favouriteListForm = this.rxFb.formGroup(FavouriteForm);
  }

  public getFavList(): void {
    this.sharedService.getFavouriteList().subscribe({
      next: (favourite: FavouriteScreens[]): void => {
        if (favourite.length === 0) {
          this.currentState = this.favouriteState.NO_LIST;
        } else {
          this.currentState = this.favouriteState.FAVOURITE_LIST;
        }
        this.favouriteList = favourite;
      },
    });
  }
}
